<template>
  <w-modal
    v-model="show"
    close-button="Anuluj"
    submit-button="Zapisz"
    title="Wybierz status"
    :close-on-submit="false"
    :hide-on-overlay="false"
    :hide-on-esc="false"
    @submit="save"
    @close="close"
  >
    <div class="row">
      <div class="form-group col-12">
        <w-select :values="statuses" :model="$schema.statusId" />
      </div>

      <div v-if="commentEnabled" class="form-group col-12">
        <w-textarea :model="$schema.comment" />
      </div>
    </div>
  </w-modal>
</template>

<script>
import { mapState } from 'vuex';

import { formMixin } from '@/mixins/form';
import { manageMixin } from '@/mixins/manage';
import schema from '@/schemas/pickStatus.schema';

const emptyData = () => ({ name: null });

// @vuese
// Modal wyboru statusu
// @group
export default {
  mixins: [manageMixin('', {}, emptyData), formMixin],
  schema,
  props: {
    // Dokument
    object: { type: Object },
    // Pole komentarza
    commentEnabled: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  data() {
    return { model: {} };
  },
  computed: {
    ...mapState({ statuses: state => state.status.list.map(status => ({ text: status.name, value: status.id })) }),
    stateData() {
      return this.object;
    }
  }
};
</script>
